export const layout = {
  width: {
    px300: "300px",
    px600: "600px",
    px960: "960px",
    px1280: "1280px",
    px1920: "1920px",
  },
};
